import { apiClient } from '@/shared/api';
import type { OrganisationConfig } from '../types';

const BASE_PATH = '/v1/admin/organisations';

export async function getOrganisationConfig(orgId: string): Promise<OrganisationConfig> {
  const response = await apiClient.get<{ data?: OrganisationConfig } & OrganisationConfig>(`${BASE_PATH}/${orgId}/config`);
  return response.data.data || response.data;
}

export async function updateOrganisationConfig(
  orgId: string,
  configId: string,
  orgConfig: Record<string, unknown>
): Promise<OrganisationConfig> {
  // POST for consistency with legacy project (not PUT)
  // Payload format: { configId, orgConfig } - as per legacy project
  const response = await apiClient.post<OrganisationConfig>(`${BASE_PATH}/${orgId}/config`, {
    configId,
    orgConfig,
  });
  return response.data;
}
